/** @jsxImportSource ../../i18n */
import React from 'react';
import { Cloud, CloudLightning, Coffee, Hand, MessageCircle, Moon, Sparkles, Sun } from 'lucide-react';
import { MASCOTS, mascotById } from '../mascotCatalog';
import { cx } from '../../theme/cx';

const MOOD_ICONS = {
  sleep: Moon, alert: Hand, storm: CloudLightning, cloudy: Cloud, calm: Sun, sunny: Sun, radiant: Sparkles, rest: Coffee,
};

const BADGE_TONES = {
  alert: 'border-warn-500/60 bg-warn-950 text-warn-300',
  storm: 'border-loss-500/50 bg-loss-950 text-loss-300',
  cloudy: 'border-line-strong bg-surface-2 text-fg-muted',
  sunny: 'border-gain-500/50 bg-gain-950 text-gain-300',
  radiant: 'border-gold-500/60 bg-gold-950 text-gold-300',
};

// Gladys' portrait in the corner: she reacts to the market (ambient mood
// from the portfolio pulse) and opens the chat. Without a mood yet, the
// plain chat button.
export const ChatLauncher = ({ onOpen, ambient, mascotVariant }) => {
  const label = ambient ? `Parler à Gladys. ${ambient.label}. ${ambient.detail}` : 'Parler à Gladys';
  const mascot = mascotById(mascotVariant) || MASCOTS[0];
  const MoodIcon = ambient ? MOOD_ICONS[ambient.mood] : null;
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={label}
      title={ambient ? `${ambient.label} — ${ambient.detail}` : 'Parler à Gladys'}
      data-mood={ambient?.mood}
      data-testid="chat-launcher"
      className="group fixed bottom-6 right-6 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full border border-gold-500/40 bg-surface-1 text-gold-300 shadow-pop transition-[transform,border-color,background-color] duration-200 ease-standard hover:-translate-y-0.5 hover:border-gold-500/70 hover:bg-surface-2 active:translate-y-0"
    >
      {ambient ? (
        <>
          {ambient.mood === 'alert' && <span aria-hidden="true" className="ambient-ring pointer-events-none absolute -inset-1 rounded-full border-2 border-warn-400" />}
          <span className={cx('block h-full w-full overflow-hidden rounded-full', `ambient-${ambient.mood}`)} data-testid="ambient-portrait">
            <img src={mascot.img} alt="" className="h-full w-full origin-[50%_6%] scale-[1.9] object-cover object-top" />
          </span>
          <span aria-hidden="true" className={cx('absolute -right-1 -top-1 inline-flex h-6 w-6 items-center justify-center rounded-full border shadow-pop', BADGE_TONES[ambient.mood] || 'border-line-strong bg-surface-2 text-fg-muted')}>
            <MoodIcon size={12} />
          </span>
          {ambient.mood === 'sleep' && (
            <span aria-hidden="true" className="pointer-events-none absolute -left-1 -top-3 font-display text-sm text-fg-muted">
              <span className="ambient-z inline-block">z</span>
              <span className="ambient-z ambient-z-2 inline-block text-xs">z</span>
            </span>
          )}
        </>
      ) : (
        <MessageCircle size={22} aria-hidden="true" />
      )}
    </button>
  );
};
